<template>
  <v-app>
    <AppBarFrame
      :session="loadSession()"
      :general="general"
      :absolute="false"
      :title="getError().title"
    />
    <v-container>
      <v-row>
        <v-col cols="2"></v-col>
        <v-col cols="8">
          <v-alert :color="getError().color" elevation="18" type="error" tile>
            {{ getError().title }}
          </v-alert>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
      <v-row>
        <v-col cols="2"></v-col>
        <v-col cols="8">
          <v-alert
            dense
            outlined
            :type="getError().type"
            class="text-center"
            :icon="false"
          >
            {{ message ? message : getError().content }}
          </v-alert>

          <v-sheet
            v-if="getError().show"
            color="transparent"
            class="text-center"
            tile
          >
            <div :class="[`text-h1`]">{{ getError().code }}</div>
          </v-sheet>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
      <v-row v-if="redirect">
        <v-col cols="2"></v-col>
        <v-col cols="8">
          <v-btn block @click="goToExternalUrl(redirect)"> Back </v-btn>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { environment } from "./../../../environment/environment.js";
import AppBarFrame from "./../main/AppBarFrame";
export default {
  name: "Error",
  props: [],
  data() {
    return {
      general: {},
      environment: environment,
      message: null,
      redirect: null,
      errors: [
        {
          code: null,
          title: "Unknown",
          content: "Unknown error",
          color: "red-darken-4",
          type: "error",
          show: false,
        },
        {
          code: "200",
          title: "Success",
          content: "Success",
          color: "green",
          type: "success",
          show: false,
        },
        {
          code: "400",
          title: "Bad Request",
          content:
            "The HyperText Transfer Protocol (HTTP) 400 Bad Request response status code indicates that the server cannot or will not process the request due to something that is perceived to be a client error.",
          color: "red-darken-4",
          type: "error",
          show: true,
        },
        {
          code: "401",
          title: "Unauthorized",
          content:
            "The HTTP 401 Unauthorized client error status response code indicates that the request has not been applied because it lacks valid authentication credentials for the target resource.",
          color: "red-darken-4",
          type: "error",
          show: true,
        },
        {
          code: "403",
          title: "Forbidden",
          content:
            "The HTTP 403 Forbidden client error status response code indicates that the server understood the request but refuses to authorize it.",
          color: "red-darken-4",
          type: "error",
          show: true,
        },
        {
          code: "404",
          title: "Not Found",
          content:
            "The HTTP 404 Not Found client error response code indicates that the server can not find the requested resource. Links that lead to a 404 page are often called broken or dead links and can be subject to link rot.",
          color: "red-darken-4",
          type: "error",
          show: true,
        },
        {
          code: "500",
          title: "Internal Server Error",
          content:
            "The HyperText Transfer Protocol (HTTP) 500 Internal Server Error server error response code indicates that the server encountered an unexpected condition that prevented it from fulfilling the request.",
          color: "red-darken-4",
          type: "error",
          show: true,
        },
        {
          code: "503",
          title: "Service Unavaliable",
          content:
            "The server is currently unable to handle the request due to a temporary overloading or maintenance of the server. The implication is that this is a temporary condition which will be alleviated after some delay.",
          color: "red-darken-4",
          type: "error",
          show: true,
        },
      ],
    };
  },
  components: {
    AppBarFrame,
  },
  methods: {
    getGeneral() {
      this.apiGetGeneral()
        .then((generalRes) => {
          this.general = generalRes.data;
        })
        .catch((generalErr) => {
          console.log(generalErr);
        });
    },
    getError() {
      let result = {};
      const code = this.$route.params.code;
      this.errors.forEach((error) => {
        if (error.code == code) {
          result = error;
        }
      });
      return result;
    },
  },
  created() {
    this.message = this.$route.query.message;
    this.redirect = this.$route.query.redirect;
    this.getGeneral();
  },
};
</script>

<style>
</style>